module.exports = require("./socket.io");



/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/client/web_modules/socket.io/index.js
 ** module id = 207
 ** module chunks = 0
 **/